import type { ComputedRef, InjectionKey, Ref } from "vue";
import type { ReportReviewPostPayload } from "@/types/api";

export interface ReportReviewContext {
  isBusy: Ref<boolean>;
  isReviewed: Ref<boolean>;
  canPersist: ComputedRef<boolean>;
  slideInfo: Ref<Record<string, unknown>>;
  cellBackendRequestObj: ComputedRef<unknown>;
  postCells: (payload: ReportReviewPostPayload) => Promise<boolean>;
  save: () => Promise<boolean>;
  resetState: () => void;
}

export type ProvidedReportReviewContext =
  | ReportReviewContext
  | Readonly<Ref<ReportReviewContext>>;

export const reportReviewInjectionKey: InjectionKey<ProvidedReportReviewContext> = Symbol(
  "blade.reportReviewContext",
);
